/*
 * This file is generated by icons/template.js
 */
const SvgTiktok = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
		<path
			fill="currentColor"
			d="M19.321 5.562a5 5 0 0 1-.443-.258 6.2 6.2 0 0 1-1.137-.966c-.849-.971-1.165-1.956-1.282-2.645h.004c-.097-.573-.057-.943-.05-.943h-3.865v14.943c0 .2 0 .399-.008.595q-.001.034-.004.073 0 .016-.003.033v.009a3.28 3.28 0 0 1-1.65 2.604 3.2 3.2 0 0 1-1.6.422c-1.8 0-3.26-1.468-3.26-3.281s1.46-3.282 3.26-3.282c.341 0 .68.054 1.004.16l.005-3.936A7.18 7.18 0 0 0 4.76 10.71a7.6 7.6 0 0 0-1.655 2.04c-.163.281-.779 1.412-.853 3.246-.047 1.04.266 2.12.415 2.565v.01c.093.262.457 1.158 1.049 1.913a7.9 7.9 0 0 0 1.674 1.58v-.01l.009.01c1.87 1.27 3.945 1.187 3.945 1.187.36-.015 1.562 0 2.928-.647 1.515-.718 2.377-1.787 2.377-1.787a7.4 7.4 0 0 0 1.296-2.153c.35-.92.466-2.022.466-2.462V8.273c.047.028.672.441.672.441s.9.577 2.303.952c1.006.267 2.363.324 2.363.324V6.153c-.475.052-1.44-.098-2.429-.59"
		/>
	</svg>
);
SvgTiktok.displayName = 'iconTiktok';
export default SvgTiktok;
